import useAppContext from '@groupefungo/react-apollo.core/app/UseContext';

export default () => {
  const { gql } = useAppContext();

  // eslint-disable-next-line import/prefer-default-export
  const MeasurementFragment = gql`
fragment MeasurementFragment on Measurement {
  bust
  underBust
  waist
  highHip
  lowHip
  hollowToWaist
  height
  weight
  braSize
  age
  notes
  hip
  document {
    id
    filename
    url
  }
}
`;

  return {
    MeasurementFragment,
  };
};
